import React from 'react';
import './About.css';
import { useNavigate } from 'react-router-dom';

function About() {
  const navigate = useNavigate();
  
  return (
    <div className="about-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h2>About Mfers Beheaded</h2>
        <button onClick={() => navigate('/')} className="nav-button">
          Home
        </button>
      </div>

      <section style={{ marginBottom: '40px' }}>
        <h3>How to Play</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '20px' }}>
          Mfers Beheaded is a match-3 puzzle game similar to Bejeweled, Candy Crush, and Royal Match. 
          Click on a tile to select it, then click on a neighboring tile to swap and form matches of 3 or more identical pieces.
        </p>
        <p style={{ fontStyle: 'italic', color: '#666' }}>Note: Drag and drop is not supported - use click to select and swap.</p>
        
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <img 
            src="/mfersbeheaded/images/help1.png" 
            alt="Game instructions" 
            style={{ maxWidth: '400px', width: '100%', border: '2px solid #ccc', borderRadius: '8px' }} 
          />
        </div>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h3>Power-Ups</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
          <strong>Top Hat Power-Up:</strong> Connect 5 or more tiles to create this special power-up. 
          When activated, it clears all tiles in both vertical and horizontal lines. Simply click on it to use.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '20px' }}>
          <strong>Special Note:</strong> In the Pixel Crush level, the power-up appears as King Spartan.
        </p>
        
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <img 
            src="/mfersbeheaded/images/help2.png" 
            alt="Power-up example 1" 
            style={{ maxWidth: '400px', width: '100%', border: '2px solid #ccc', borderRadius: '8px', marginBottom: '10px' }} 
          />
          <img 
            src="/mfersbeheaded/images/help3.png" 
            alt="Power-up example 2" 
            style={{ maxWidth: '400px', width: '100%', border: '2px solid #ccc', borderRadius: '8px' }} 
          />
        </div>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h3>Twitter Authentication</h3>
        <p style={{ lineHeight: '1.6' }}>
          Mfers Beheaded supports "Sign in with Twitter" using OAuth 1.0 to verify your identity for leaderboards. 
          We use the least privileged level of Twitter API access - we cannot read your tweets, followers, or any private information.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h3>Privacy & Data</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
          <strong>What we collect:</strong> Game data for leaderboards and analytics including your chosen identifier 
          (Twitter username/ID or provided name), score, time, moves, level, and device user-agent.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
          <strong>What we don't collect:</strong> IP addresses, geographic location, or detailed device information.
        </p>
        <p style={{ lineHeight: '1.6', fontWeight: 'bold' }}>
          Game data is only stored if you choose to sign in via Twitter or provide a name.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h3>Development Team</h3>
        <p style={{ lineHeight: '1.6' }}>
          Mfers Beheaded is created by <strong>nngmi</strong> and <strong>bloodisher</strong>.
        </p>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h3>Credits & Licensing</h3>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
          <strong>Mfers:</strong> CC0 public domain artwork by Sartoshi
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
          <strong>Nakamigos:</strong> Individual pieces used with permission from owners Shatt_Eth, Faded Alpha, and Soldman Gachs
        </p>
        <p style={{ lineHeight: '1.6' }}>
          <strong>Additional Art & Music:</strong> Various contributors as credited in individual levels
        </p>
      </section>
    </div>
  );
}

  export default About;